/* eslint-disable eqeqeq */
import React, { memo, useEffect, useState } from 'react';
import { Button } from 'antd';

const Contador = ({ count, onChange }) => <div className='d-block btn-count-prd-group'>
    <Button
        className='btn-count-prd mr-15'
        shape="circle"
        disabled={count == 0}
        onClick={(e) => onChange(e, -1)}
    >-
    </Button>
    {count}
    <Button
        className='btn-count-prd ml-15'
        shape="circle"
        onClick={(e) => onChange(e, 1)}
    >+
    </Button>
</div>

export const Item = memo(({
    index,
    nombre,
    count,
    descripcion,
    precio,
    onChangeCount
}) => {
    const [value, setValue] = useState(0);
    const onChange = (e, newValue) => {
        e.preventDefault();
        setValue(value + newValue)
        onChangeCount(index, value + newValue)
    }
    useEffect(() => {
        setValue(count);
    }, [count]);
    return (
        <div
            key={"list-prd-" + index}
            className='item-prd mb-5'
            onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
        >
            <div className='d-flex mb-2'>
                <p className='inpt-text-prd fw-bold'>{nombre}</p>

                <Contador count={value} onChange={onChange} />
            </div>
            <div className='d-flex'>
                <p className='inpt-text-prd'>{descripcion}</p>
                <div className='prd-total'>$ {(new Intl.NumberFormat('de-DE').format(precio))}</div>
            </div>
        </div>
    )
})

export const LabelError = ({ error }) => (
    <label className="label-error-productos">{error}</label>
)